<template>
  <v-container class="container-wrapper" style="height: 300px">
    <v-alert
        :value="showSuccess"
        color="light-blue"
        dark
        transition="scale-transition"
        class="multi-line"
    >
      Congratulations! <br>
      You've just earned points for the purchase scanned. <br>
      Keep accumulating points to redeem for exclusive perks and discounts. <br>
    </v-alert>
    <v-alert
             :value="!showSuccess && errorMessage != null"
             color="blue-grey"
             dark
             transition="scale-transition"
             class="multi-line"
    >
      Sorry...<br>
      {{errorMessage}}
    </v-alert>
  </v-container>
</template>
<script>
export default {
  name: "Completed",
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.purchaseId = urlParams.get('purchaseId');
    this.showSuccess = urlParams.get('showSuccess') === 'true';
    this.errorMessage = urlParams.get('errorMessage');
    this.purchaseTotalSum = urlParams.get('purchaseTotalSum');
    let message = '';
    if(this.purchaseTotalSum){
        message = `with a total sum of ${this.purchaseTotalSum}`;
    }
    this.purchaseTotalSumMessage = `Purchase ${message} was processed.`;
  },
  watch: {
  },
  data: () => ({
    showSuccess: null,
    purchaseTotalSum: null,
    errorMessage: null,
    purchaseTotalSumMessage: ''
  }),
  props: {
  },
  methods: {
  },
  computed: {
  },
  components: {

  }
}
</script>
<style>
.multi-line {
  white-space: pre-line;
}
.loader {
  margin: 100px auto;
  font-size: 25px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load5 1.1s infinite ease;
  animation: load5 1.1s infinite ease;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #924545, 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.5), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.7), 1.8em -1.8em 0 0em #924545, 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.5), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.7), 2.5em 0em 0 0em #924545, 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.5), 2.5em 0em 0 0em rgba(146, 69, 69, 0.7), 1.75em 1.75em 0 0em #924545, 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.5), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.7), 0em 2.5em 0 0em #924545, -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.5), 0em 2.5em 0 0em rgba(146, 69, 69, 0.7), -1.8em 1.8em 0 0em #924545, -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.5), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.7), -2.6em 0em 0 0em #924545, -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.5), -2.6em 0em 0 0em rgba(146, 69, 69, 0.7), -1.8em -1.8em 0 0em #924545;
  }
}
@keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #924545, 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.5), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.7), 1.8em -1.8em 0 0em #924545, 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.5), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.7), 2.5em 0em 0 0em #924545, 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.5), 2.5em 0em 0 0em rgba(146, 69, 69, 0.7), 1.75em 1.75em 0 0em #924545, 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.5), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.7), 0em 2.5em 0 0em #924545, -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.5), 0em 2.5em 0 0em rgba(146, 69, 69, 0.7), -1.8em 1.8em 0 0em #924545, -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.5), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.7), -2.6em 0em 0 0em #924545, -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.5), -2.6em 0em 0 0em rgba(146, 69, 69, 0.7), -1.8em -1.8em 0 0em #924545;
  }
}
</style>
